import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";


// Créer un Event
export const CreateEvent = (title, coverPicture, description, date, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "date": date,
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/activites/event/`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      redirect(`/${AllRoutes.admin}/${AllRoutes.activity}#evevenements`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
    });
}

// Mise ajour du Témoignage
export const UpdateEvent = (id, title, coverPicture, description,date,visible, redirect) => {
  var data = JSON.stringify({
    "title": title,
    "coverPicture": coverPicture,
    "description": description,
    "date": date,
    "visible":visible
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/activites/event/${id}`,
    headers: {
      'Authorization': 'Bearer ',
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      // redirect(`/${AllRoutes.admin}/${AllRoutes.activity}#evenments`);
      window.location.reload();
    })
    .catch(function (error) {
      // console.log(error);
    });

}

// Recupérer tout les programes
export const LoadAllEvent = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/activites/event/get/all`, {
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      // console.log(error);
    });
}


